<template>
  <span></span>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "checkReceiptToken",
  mounted() {
    const token = this.$route.query['token']
    const campaignId = this.$route.query['campaignId'];
    if (campaignId) {
      this.$store.commit("setCampaignId", campaignId)
    }

    this.check72Hours({ token, campaignId })
      .then(res => {
        if (!res.response) {
          location.href = 'expired'
        }
      })
  },
  methods: {
    ...mapActions(['check72Hours'])
  }
}
</script>